import { teamSection } from '@stereoagency/sanity-schema';
import compact from 'just-compact';
import UITeamSection from './TeamSection.client';
import { $globalSanityClient } from '@/sanity';
import { profilesQuery } from './profilesQuery';

type Props = typeof teamSection.schema.teamSection;

export default async function TeamSection({ title, subtitle, members }: Props) {
  const ids = compact(members?.map((member) => member.profile?._ref) ?? []);
  const profiles = await $globalSanityClient.fetch<(typeof profilesQuery)[1]>(
    profilesQuery[0],
    { ids }
  );

  return (
    <UITeamSection
      title={title}
      subtitle={subtitle}
      members={members}
      profiles={profiles}
    />
  );
}
